import Vue from 'vue';
import { ActivePopupTypes } from '@/store/modules/popup/types';
var EditModes;
(function (EditModes) {
    EditModes["default"] = "default";
    EditModes["edit"] = "edit";
})(EditModes || (EditModes = {}));
export default Vue.extend({
    name: 'whitelistsEditAddress',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            mode: EditModes.default,
            form: {
                valid: false,
                fields: {
                    name: {
                        value: '',
                        rules: [
                            (v) => Boolean(v) || this.$t('whitelistsPage.errors.fieldCantBeEmpty')
                        ]
                    }
                }
            },
            codeError: false
        };
    },
    computed: {
        resolvedNetworkData() {
            const isAdded = Boolean(this.item.network);
            const isIncorrect = !this.item.isValidAddress;
            return {
                isAdded: isAdded,
                isIncorrect: isIncorrect,
                text: !isAdded
                    ? this.$t('whitelistsPage.addNetwork')
                    : isIncorrect
                        ? this.$t('whitelistsPage.addressIncorrect')
                        : this.item.network
            };
        },
        computedAddress() {
            if (this.item.address && this.item.addressVisible)
                return this.item.address;
            return this.item.blurredAddress ? this.item.blurredAddress : '*******************************';
        }
    },
    watch: {
        'item.name'(v) {
            this.form.fields.name.value = v;
        }
    },
    methods: {
        closeEditAddress() {
            this.$emit('deselectAll');
        },
        doBeginEditName() {
            this.mode = EditModes.edit;
        },
        cancelEditName() {
            this.mode = EditModes.default;
            if (this.item.name.trim() !== this.form.fields.name.value.trim()) {
                this.$emit('onChangeItemName', { id: this.item.id, newName: this.form.fields.name.value });
            }
            else {
                this.form.fields.name.value = this.item.name;
            }
        },
        handleClickDeleteAddress() {
            const vm = this;
            const popupData = {};
            let secret = '';
            if (vm.codeError)
                popupData.errors = [vm.$t('whitelistsPage.errors.invalidCode')];
            vm.$store.dispatch('popupModule/openPopup', {
                type: ActivePopupTypes.action,
                letDefaultClose: true,
                title: vm.$t('whitelistsPage.popups.titles.confirmOperation'),
                content: vm.$t('whitelistsPage.popups.content.enterSecretCodeToDeleteAddress'),
                slot: {
                    name: 'confirmActionPopupChunk',
                    data: popupData,
                    on: {
                        onChangeSecretField(v) { secret = v; },
                        onConfirm(secret) {
                            vm.$store.commit('popupModule/setClosed');
                            vm.$emit('onDeleteAddress', secret);
                        },
                        onClickBeginReset() {
                            vm.$store.commit('popupModule/setClosed');
                            vm.codeError = false;
                            vm.$emit('onClickBeginReset');
                        }
                    }
                }
            });
        },
        toggleAddressVisibility() {
            const vm = this;
            if (vm.item.addressVisible) {
                vm.$emit('onToggleAddressVisibility', { id: vm.item.id, address: '' });
            }
            else {
                vm.$store.dispatch('popupModule/openPopup', {
                    type: ActivePopupTypes.action,
                    letDefaultClose: true,
                    title: vm.$t('whitelistsPage.popups.titles.confirmOperation'),
                    content: vm.$t('whitelistsPage.popups.content.enterSecretKeyToShowAddress', { name: vm.form.fields.name.value }),
                    slot: {
                        name: 'confirmActionPopupChunk',
                        data: {},
                        on: {
                            onConfirm(secret) {
                                const haveError = secret.length < 2;
                                vm.$store.commit('popupModule/setClosed');
                                if (haveError) {
                                    vm.codeError = true;
                                    vm.toggleAddressVisibility();
                                }
                                else {
                                    vm.$emit('onToggleAddressVisibility', { id: vm.item.id, secret });
                                }
                            },
                            onClickBeginReset() { vm.$emit('onClickBeginReset'); }
                        }
                    }
                });
            }
        }
    },
    created() {
        const vm = this;
        if (vm.item.name) {
            vm.form.fields.name.value = vm.item.name;
        }
    }
});
